/**
 * Barrinha do cartão editada direto nela (o `TRExtStatusBarEditorLayout` do original): o que se
 * digita em "valor atual" e "máximo". Como no original (`TryDecodeBarValueChangeIntention`):
 * - "12" ou "=12": o número (com "=", também negativo: "=-2");
 * - "+5" e "-3": soma ou tira do que está lá;
 * - outra coisa, ou vazio: o campo fica como estava.
 * Aceita vírgula ou ponto como separador decimal.
 */

const NUMBER = String.raw`(?:\d+(?:\.\d*)?|\.\d+)`;
const ABSOLUTE = new RegExp(`^=?\\s*(-?${NUMBER})$`);
const RELATIVE = new RegExp(`^([+-])\\s*(${NUMBER})$`);

/** sem lixo de ponto flutuante (0,1 + 0,2) */
const tidy = (n: number) => Math.round(n * 1e4) / 1e4;

/** O número que o texto pede, partindo de `current`. */
export function applyBarInput(text: string, current: number): number {
  const s = text.trim().replace(',', '.');
  const relative = RELATIVE.exec(s);
  if (relative) return tidy(relative[1] === '+' ? current + Number(relative[2]) : current - Number(relative[2]));
  const absolute = ABSOLUTE.exec(s);
  // sem "=", o "-3" já foi lido como relativo acima
  if (absolute && (s.startsWith('=') || !absolute[1]!.startsWith('-'))) return tidy(Number(absolute[1]));
  return current;
}

export type BarValues = { value: number; max: number };

/**
 * O que o editor grava: a barra nova; `null` para tirar a barra (máximo 0 ou menos, como no
 * diálogo do cartão); `undefined` quando nada muda.
 */
export function barEditResult(bar: BarValues | null, valueText: string, maxText: string): BarValues | null | undefined {
  const value = applyBarInput(valueText, bar?.value ?? 0);
  const max = applyBarInput(maxText, bar?.max ?? 0);
  if (max <= 0) return bar ? null : undefined;
  if (bar && bar.value === value && bar.max === max) return undefined;
  return { value, max };
}
